import React, { useState, useEffect } from 'react';

interface SearchEmbedMainProps {
  searchFormId: string;
  areaOfExpertiseId: string;
}

const SearchEmbedMain = (props: SearchEmbedMainProps) => {
  const { searchFormId, areaOfExpertiseId } = props;
  const [isRender, setIsRender] = useState(true);

  const formDefaults = {
    area_of_expertise: `${areaOfExpertiseId}`, // Force this to render as a string
  };

  useEffect(() => {
    const handleHashChange = () => {
      setIsRender(false);
      history.pushState('', document.title, window.location.pathname + window.location.search);

      setTimeout(() => {
        setIsRender(true);
      }, 500);
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  useEffect(() => {
    const handleLeadFormRendered = () => {
      const leadFormDiv = document.querySelector(`[data-leadform-id="${searchFormId}"]`);
      if (!leadFormDiv) {
        return;
      }

      const firstSelect = leadFormDiv.querySelector('select');
      if (!firstSelect) {
        return;
      }

      const closestGfield = firstSelect.closest<HTMLDivElement>('.gfield');
      if (!closestGfield) {
        return;
      }

      closestGfield.style.display = 'none';
    };

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const leadFormDiv = document.getElementById(`gform_wrapper_${searchFormId}`);
          if (!leadFormDiv) {
            return;
          }

          handleLeadFormRendered();
          break;
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      {isRender
        ? <div className="o-lead-form lead-form-block lead-form-wrapper">
            <div data-leadform-id={searchFormId} data-defaults={JSON.stringify(formDefaults)} key="rendered"></div>
          </div>
        : <div className="check-salary-search-embed__loading" key="loading">
            <div className="check-salary-search-embed__loading-overlay"></div>
          </div>
      }
    </>
  );
};

export { SearchEmbedMain };
